import { openDB } from 'idb'

const getDB = () =>
  openDB('polar-h10-v2', 4, {
    upgrade(db, oldVersion) {
      if (oldVersion < 1) {
        const s = db.createObjectStore('readings', { keyPath: 'time' })
        s.createIndex('time', 'time')
        db.createObjectStore('segments', { keyPath: 'id', autoIncrement: true })
      }
      if (oldVersion < 2) {
        db.createObjectStore('drafts', { keyPath: 'key' })
      }
      if (oldVersion < 3) {
        // Buzón de salida: sesiones que no pudieron subirse (sin señal) esperan
        // acá y se suben solas cuando vuelve la conexión.
        db.createObjectStore('outbox', { keyPath: 'id', autoIncrement: true })
      }
      if (oldVersion < 4) {
        db.createObjectStore('acc_recordings', { keyPath: 'sessionId' })
      }
    },
  })

export async function addReadings(arr) {
  if (!arr.length) return
  const db = await getDB()
  const tx = db.transaction('readings', 'readwrite')
  await Promise.all(arr.map(r => tx.store.put(r)))
  await tx.done
}

export async function getReadings(fromTime, toTime) {
  const db    = await getDB()
  const range = (fromTime || toTime)
    ? IDBKeyRange.bound(fromTime ?? 0, toTime ?? Date.now())
    : undefined
  const all = await db.getAll('readings', range)
  return all.sort((a, b) => a.time - b.time)
}

export async function addSegment(startTime, endTime, source = 'polar', deviceName = null) {
  const db = await getDB()
  return db.add('segments', { startTime, endTime, source, deviceName })
}

export async function getSegments() {
  const db = await getDB()
  return db.getAll('segments')
}

export async function saveDraft(readings, source, deviceName) {
  if (!readings.length) return
  const db = await getDB()
  return db.put('drafts', { key: 'current', readings, source, deviceName, savedAt: Date.now() })
}

export async function getDraft() {
  const db = await getDB()
  return db.get('drafts', 'current')
}

export async function clearDraft() {
  const db = await getDB()
  return db.delete('drafts', 'current')
}

// ── Buzón de salida (modo offline) ───────────────────────────────────────────
export async function addToOutbox(session, readings) {
  const db = await getDB()
  return db.add('outbox', { session, readings, createdAt: Date.now() })
}

export async function getOutbox() {
  const db = await getDB()
  return db.getAll('outbox')
}

export async function removeFromOutbox(id) {
  const db = await getDB()
  return db.delete('outbox', id)
}

// ── Grabaciones crudas de acelerómetro (local IndexedDB) ───────────────────────
export async function saveAccRecording(sessionId, accData) {
  if (!sessionId || !accData) return
  const db = await getDB()
  return db.put('acc_recordings', { sessionId, accData, savedAt: Date.now() })
}

export async function getAccRecording(sessionId) {
  if (!sessionId) return null
  const db = await getDB()
  const row = await db.get('acc_recordings', sessionId)
  return row?.accData ?? null
}
